import { useLocation } from 'react-router-dom'

import { parseParams, type ParsedQueryParams } from './parseParams'

/** React router search params */
export const useSearchParams = (defaults?: ParsedQueryParams) => {
    const { search } = useLocation()

    return parseParams(search, defaults)
}
